if (!customElements.get('bm-landing-hero-slider')) {
  class BmLandingHeroSlider extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.bm-landing-hero__swiper');
      if (!this.swiperEl) return;

      const slideCount = this.getSlideCount();
      if (slideCount <= 1) return;

      this.initSlider(slideCount);
    }

    disconnectedCallback() {
      if (this.carousel?.slider) {
        this.carousel.slider.destroy(true, true);
        this.carousel = null;
      }
    }

    getSlideCount() {
      const fromAttr = parseInt(this.dataset.slideCount, 10);
      if (Number.isFinite(fromAttr) && fromAttr > 0) return fromAttr;
      return this.swiperEl.querySelectorAll('.swiper-slide').length;
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    getPaginationEl() {
      return (
        this.parentElement?.querySelector('[data-bm-landing-hero-pagination]') ||
        this.querySelector('.bm-landing-hero__pagination')
      );
    }

    initSlider(slideCount) {
      const paginationEl = this.getPaginationEl();
      const autoplayDelay = parseInt(this.dataset.autoplay, 10) || 4000;
      const autoplayEnabled =
        this.dataset.autoplayEnabled === 'true' && !this.prefersReducedMotion();

      const modules = [FoxTheme.Swiper.EffectFade];
      const options = {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: slideCount > 1,
        grabCursor: true,
        threshold: 2,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : false,
        on: {
          slideChangeTransitionStart: () => this.restartPaginationFill(),
        },
      };

      if (autoplayEnabled) {
        options.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        };
        modules.push(FoxTheme.Swiper.Autoplay);
      }

      this.carousel = new FoxTheme.Carousel(this.swiperEl, options, modules);
      this.carousel.init();
    }

    restartPaginationFill() {
      const pagination = this.getPaginationEl();
      if (!pagination) return;

      pagination.classList.add('bm-landing-hero__pagination--restart-fill');
      requestAnimationFrame(() => {
        pagination.classList.remove('bm-landing-hero__pagination--restart-fill');
      });
    }
  }

  customElements.define('bm-landing-hero-slider', BmLandingHeroSlider);
}
